import { Injectable } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';

type style = 'none' | 'success' | 'warning' | 'error' | 'info';

@Injectable()
export class MessageService {
	constructor(private notificationService: NotificationService) {}
	show(content = 'Opération réussi', typeStyle: style = 'success') {
		this.notificationService.show({
			content: content,
			animation: { type: 'fade', duration: 400 },
			position: { horizontal: 'center', vertical: 'top' },
			type: { style: typeStyle, icon: true },
			hideAfter: 2000
		});
	}
}
